// @flow
import * as React from 'react';
import { Alert, Divider, Stack, Typography } from '@mui/material';
import { OutdatedSqlAlert } from './items/outdated-sql-alert';
import { useEffect, useRef, useState } from 'react';
import { NoData } from '../../../../../../shared';
import { OutdatedFollowUpAlert } from './items/outdated-follow-up-alert';
import { OutdatedNextActionsAlert } from './items/outdated-next-actions-alert';

type Props = {
  agentId?: string
};
export const AlertList = ({agentId}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  /*const [alertsCount, setAlertsCount] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setAlertsCount(ref.current.childElementCount);
    }
  }, [ref]);*/


  return (<Stack gap={2} flex={1}>
    <Stack gap={1}>
      <Typography variant={'subtitle1'}>Alerts</Typography>
      <Divider />
    </Stack>

    <Stack gap={1} ref={ref}>
      <OutdatedSqlAlert agentId={agentId} />
      <OutdatedFollowUpAlert agentId={agentId} />
      {/*<OutdatedNextActionsAlert agentId={agentId} />*/}
    </Stack>
    {/*!alertsCount && <NoData>No alerts</NoData>*/}
  </Stack>
  );
};
